export default "__VITE_ASSET__CiXch0Q6__"